import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertEvent',
    standalone: true
})
export class ConvertEventPipe implements PipeTransform {
  text:any = { "Generated event": "events.generated_event", "Flow event": "events.flow_event", "User defined": "events.user_defined", "Tracker log": "events.tracker_log", "Risk": "events.risk_event"};

  transform(value: string): string {
    return this.text[value] || ""; 
  }

}
